import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useGlobalState } from "../../store";
import { removeUser } from "../../blockchain";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { SERVER_URL } from "../../config";
import DialogActions from "@material-ui/core/DialogActions";
import moment from 'moment';

const styles = (theme) => ({
    root: {
          margin: "2rem 4rem",
          border: "1px solid rgba(0,0,0,0.1)",
          width: "calc(100% - 8rem)",
    },
    button: {
          verticalAlign: "top",
          marginLeft: "0.5rem",
    },
    tableRow: {
          "&:nth-of-type(odd)": {
                  backgroundColor: "#00000006",
          },
    },
    tableCell: {
          fontWeight: "bold",
          padding: "0.5rem 3rem",
          color: "#333333",
    },
    link: {
          textDecoration: "underline",
          "&:hover": {
                  color: "#cc0000",
                  cursor: "pointer",
          },
    },
    dialogHeader: {
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          cursor: "pointer",
    },
});

function UserTable(props) {
    const { classes, plans } = props;
    const [userLedger] = useGlobalState("userLedger");
    const [, setConfirm] = useGlobalState("confirm");
    const [removing, setRemoving] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [viewPlanData, setViewPlanData] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedUserPlan, setSelectedUserPlan] = useState(null);
    const [editingUserId, setEditingUserId] = useState(null);
    const [openEditDialog, setEditDialog] = useState(false);
    const [saving, setSaving] = useState(false);

  const _removeUser = (address, name) => {
        setConfirm({
                show: true,
                text: `Do you want to remove ${name} from MediSend?`,
                ok: async () => {
                          try {
                                      setRemoving(address);
                                      await removeUser(address);
                                      setRemoving(null);
                          } catch (e) {
                                      setRemoving(null);
                          }
                },
        });
  };

  const editPlan = async (address) => {
        let userId = address;
        setEditingUserId(address);
        const response = await fetch(
                `${SERVER_URL}/getUserWisePlanData?userId=${userId}`,
          {
                    headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                    },
          }
              );
        const jsonResponse = await response.json();
        const data = jsonResponse.data;
        console.log("getuserwiseplanData", data);
        setSelectedUserPlan(data);

        // Pre-select the user's current plan in the dropdown by matching planId
        const matchingPlan = plans.find((p) => p.planId === data?.planId) || null;
        setSelectedPlan(matchingPlan);
        setEditDialog(true);
  };

  const openPlanDialog = async (address) => {
        let userId = address;
        const response = await fetch(
                `${SERVER_URL}/getUserWisePlanData?userId=${userId}`,
          {
                    headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                    },
          }
              );
        const jsonResponse = await response.json();
        const data = jsonResponse.data;
        setViewPlanData(data);
        setOpenDialog(true);
  };

  const saveUserPlan = async () => {
        if (!selectedPlan) {
                alert("Please select a plan first.");
                return;
        }

        const userId = editingUserId || selectedUserPlan?.userId;
        if (!userId) {
                alert("Unable to determine user ID. Please try again.");
                return;
        }

        console.log("Saving plan for userId:", userId, "planId:", selectedPlan.planId);
        setSaving(true);

        try {
                const response = await fetch(
                          `${SERVER_URL}/edituserplan?userId=${userId}`,
                  {
                              method: "PUT",
                              headers: {
                                            Accept: "application/json",
                                            "Content-Type": "application/json",
                              },
                              body: JSON.stringify({
                                            planId: selectedPlan.planId,
                                            planDuration: selectedPlan.timeDuration,
                              }),
                  }
                        );

          if (!response.ok) {
                    const errorData = await response.json();
                    console.error("Failed to update plan:", errorData);
                    alert("Failed to update plan: " + (errorData.message || response.statusText));
                    return;
          }

          const jsonResponse = await response.json();
                console.log("Plan updated successfully", jsonResponse);
                setEditDialog(false);
                setSelectedPlan(null);
                setSelectedUserPlan(null);
                setEditingUserId(null);
        } catch (err) {
                console.error("Error saving plan:", err);
                alert("An error occurred while saving the plan. Please try again.");
        } finally {
                setSaving(false);
        }
  };

  const closePlanDialog = () => {
        setSelectedPlan(null);
        setViewPlanData(null);
        setEditingUserId(null);
        setOpenDialog(false);
        setEditDialog(false);
  };

  if (!userLedger) return <div />;

      return (
            <Paper className={classes.root} elevation={0}>
              <TableContainer component={Paper}>
            <Table className={classes.table}>
          <TableBody>
  {Object.values(userLedger).map((client, i) => {
                  // console.log(userLedger)
                                               const { address, name, hpio, url, details } = client;
                  return (
                                    <TableRow className={classes.tableRow} key={i}>
                      <TableCell
                      className={`${classes.tableCell} ${classes.link}`}
                    onClick={() =>
                      window.open(
                                                `https://ropsten.etherscan.io/address/${address}`,
                                                "_blank"
                                              )
                      }
                  >
                    {address}
                      </TableCell>
                  <TableCell className={classes.tableCell}>{name}</TableCell>
                  <TableCell className={classes.tableCell}>{hpio}</TableCell>
                  <TableCell
                    className={`${classes.tableCell} ${classes.link}`}
                    onClick={() => window.open(url, "_blank")}
                  >
{url}
</TableCell>
                  <TableCell className={classes.tableCell}>{details}</TableCell>
                  <TableCell className={classes.tableCell}>
                    <Button
                      variant="text"
                      color="primary"
                      style={{ display: "flex", whiteSpace: "nowrap" }}
                      onClick={() => openPlanDialog(address)}
                    >
                      View Plan
                        </Button>
                        </TableCell>
                  <TableCell>
                                            <div style={{ display: "flex" }}>
                      <IconButton
                        aria-label="delete"
                        disabled={removing}
                        className={removing === address ? "rotate" : ""}
                                                  onClick={() => _removeUser(address, name)}
                      >
                        <DeleteIcon fontSize="small" />
                        </IconButton>
                      <IconButton
                        aria-label="edit"
                        disabled={removing}
                        className={removing === address ? "rotate" : ""}
                                                  onClick={() => editPlan(address)}
                      >
                        <EditIcon fontSize="small" />
                        </IconButton>
                        </div>
                        </TableCell>
                        </TableRow>
              );
})}
</TableBody>
  </Table>
  </TableContainer>

{/* Plan Details Dialog */}
      <Dialog
        open={openDialog}
        onClose={closePlanDialog}
        maxWidth="sm"
        fullWidth
      >
                  <div className={classes.dialogHeader}>
          <DialogTitle>{`User Plan Details`}</DialogTitle>
          <IconButton aria-label="close" onClick={closePlanDialog}>
                      <CloseIcon />
          </IconButton>
          </div>
        <DialogContent>
        {viewPlanData ? (
                      <>
                        <p>
                          <strong>User Id : </strong> {viewPlanData.userId || "-"}
          </p>
              <p>
                          <strong>Plan Name :</strong> {viewPlanData.planName || "-"}
          </p>
              <p>
                          <strong>Device Limit :</strong> {viewPlanData.maxDevice || "-"}
          </p>
              <p>
                          <strong>Validity Period :&nbsp;</strong>
{viewPlanData.timeDuration
                   ? viewPlanData.timeDuration + " Year"
                    : "-"}
</p>
              <p>
                  <strong>createdTime : </strong>
{moment.unix(viewPlanData.createdTime).format("MM/DD/YYYY hh:mm:ss A") || "-"}
</p>
              <p>
                  <strong>expirationTime : </strong>
{moment.unix(viewPlanData.expirationTime).format("MM/DD/YYYY hh:mm:ss A") || "-"}
</p>
  </>
          ) : (
                        <p>No data found for the selected user.</p>
          )}
</DialogContent>
            </Dialog>

{/* Edit Plan Details Dialog */}
      <Dialog
        open={openEditDialog}
        onClose={closePlanDialog}
        maxWidth="sm"
        fullWidth
      >
                  <div className={classes.dialogHeader}>
          <DialogTitle>{`Edit Plan Details`}</DialogTitle>
          <IconButton aria-label="close" onClick={closePlanDialog}>
                      <CloseIcon />
          </IconButton>
          </div>
        <DialogContent>
                    <FormControl variant="standard" style={{ width: "100%" }}>
            <InputLabel id="plan-label">Select Plan</InputLabel>
            <Select
              labelId="plan-label"
              id="plan"
              value={selectedPlan || ""}
              onChange={(event) => setSelectedPlan(event.target.value)}
              style={{ width: "100%", marginRight: "8rem" }}
              renderValue={(p) => p.planName}
            >
{plans.map((plan, index) => (
                  <MenuItem key={index} value={plan}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: "bold" }}>{plan.planName}</span>
                    <span>Device Limit: {plan.maxDevice}</span>
                    <span>Expiry: {plan.timeDuration} Year</span>
  </div>
  </MenuItem>
              ))}
                </Select>
                </FormControl>
                </DialogContent>
        <DialogActions>
                          <Button onClick={closePlanDialog} color="primary">
                            Cancel
                </Button>
          <Button
            color="primary"
            onClick={saveUserPlan}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
</Button>
  </DialogActions>
  </Dialog>
  </Paper>
  );
}

export default withStyles(styles)(UserTable);
